/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Self_OrganizedInputs */



/**
* | output |
* | --- |
* | "Self-organized rounds" |
*
* @param {Og_Cfg_Self_OrganizedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_self_organized = /** @type {((inputs?: Og_Cfg_Self_OrganizedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Self_OrganizedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes auto-organisées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas auto-organizadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas auto-organizadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round auto-organizzati")
	return /** @type {LocalizedString} */ ("Self-organized rounds")
});